import { AgenticPage } from "@app/pages/app/agentic/page";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import SettingWidget from "../widgets/SettingWidget";
import SaveWidget from "../widgets/SaveWidget";
import DesignerVersionWidget from "../widgets/DesignerVersionWidget";
import { ChangeLog } from "../widgets";
import ValidatorDialog from "../widgets/dialogs/ValidatorDialog";
import DisabledInFlowDialog from '../widgets/dialogs/DisabledInFlowDialog';
import CommonModuleDefaultsDialog from '../widgets/dialogs/CommonModuleDefaultsDialog';
import IntentsWidget from "../widgets/IntentsWidget";
import TestToolWidget from "../widgets/TestToolWidget";
import DialogWidget from "../widgets/DialogWidget";
import Utility from "./../utilities/Utility";
import DesignerSetting from '../DesignerSetting';
import { IntentLayout } from "../pages/app/intent/layout";

/**
 * Handles all rendering of Application React Components via ReactDOM.render
 */
export class ReactDOMComponents {
    get intentLayout() {
        return (
            <BrowserRouter basename="/app/intent">
                <IntentLayout />
            </BrowserRouter>
        );
    }

    // settings, save, intents, designer-version, changelog
    renderApplicationPages(serialized) {
        const labels = window.l;
        const IS_COMMON_MODULE_APP = Utility.getIsCommonModule(serialized);
        const IS_CLIENT_VIEW = DesignerSetting.s.is_public === "true";

        if (IS_CLIENT_VIEW) {
            ReactDOM.render(<SettingWidget
                serialized={serialized}
                labels={labels.settings} />, $("#settings").get(0));

            ReactDOM.render(
                <IntentsWidget
                    serialized={serialized}
                    labels={labels.intents}
                >
                    {this.intentLayout}
                </IntentsWidget>,
                $("#intents").get(0)
            );

            ReactDOM.render(<DesignerVersionWidget 
                />, $(".designer-version-container").get(0));
        } else if(IS_COMMON_MODULE_APP) {
            ReactDOM.render(<SettingWidget
                serialized={serialized}
                labels={labels.settings} />, $("#settings").get(0));

            ReactDOM.render(<SaveWidget
                serialized={serialized}
                labels={labels.save} />, $("#save").get(0));

            ReactDOM.render(<DesignerVersionWidget 
                />, $(".designer-version-container").get(0));

        } else {
            ReactDOM.render(<AgenticPage />, $("#agentic").get(0));

            ReactDOM.render(<SettingWidget
                serialized={serialized}
                labels={labels.settings} />, $("#settings").get(0));

            ReactDOM.render(<SaveWidget
                serialized={serialized}
                labels={labels.save} />, $("#save").get(0));

            ReactDOM.render(
                <IntentsWidget
                    serialized={serialized}
                    labels={labels.intents}
                >
                    {this.intentLayout}
                </IntentsWidget>,
                $("#intents").get(0)
            );

            ReactDOM.render(<DesignerVersionWidget 
                />, $(".designer-version-container").get(0));

            ReactDOM.render(<TestToolWidget
                serialized={serialized}
                />, $("#testTool").get(0));

            ReactDOM.render(<DialogWidget
                serialized={serialized}
                />, $("#dialogs").get(0));
        }

    }

    render({ name, props, $el }) {
        const labels = window.l;

        switch (name) {
            case 'SettingWidget':
                ReactDOM.render(<SettingWidget
                    {...props}
                    labels={labels.settings} />, $($el).get(0));
                break;
            case 'SaveWidget':
                ReactDOM.render(<SaveWidget
                    {...props}
                    labels={labels.save} />, $($el).get(0));
                break;
            case 'ChangeLog':
                ReactDOM.render(<ChangeLog {...props} />, $($el).get(0));
                break;
            case 'IntentsWidget':
                ReactDOM.render(
                    <IntentsWidget
                        {...props}
                    >
                        {this.intentLayout}
                    </IntentsWidget>,
                    $($el).get(0)
                );
                break;
            case 'TestToolWidget':
                ReactDOM.render(<TestToolWidget {...props} />, $($el).get(0));
                break;
            default:
                break;
        }
    }

    renderDialog({ name, props, $el }) {
        switch (name) {
            case 'changeLogDialog':
                ReactDOM.render(
                    <ChangeLog {...props} />,
                    $($el).get(0)
                );
                break;
            case 'validatorDialog':
                ReactDOM.render(
                    <ValidatorDialog {...props} />,
                    $($el).get(0));
                break;
            case 'disabledItemsDialog':
                ReactDOM.render(
                    <DisabledInFlowDialog {...props} />,
                    $($el).get(0));
                break;
            case 'setCommonModuleDefaults':
                ReactDOM.render(
                    <CommonModuleDefaultsDialog {...props} />,
                    $($el).get(0));
                break;
            default:
                break;
        }
    }

    unmountComponentAtNode($el) {
        ReactDOM.unmountComponentAtNode($($el).get(0));
    }
}
